import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderTop: `solid 1px ${theme.colorPalette.beige_50}`,
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    padding: theme.spacing(4, 8),
    position: 'relative'
  },
  completed: {
    backgroundColor: theme.colorPalette.beige_25
  },
  task: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  taskInfo: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(2),
    width: '100%'
  },
  taskInfoCompleted: {
    gridTemplateColumns: '2fr 1fr'
  },
  taskName: {
    whiteSpace: 'nowrap',
    color: theme.colorPalette.green_80,
    lineHeight: 1.5
  },
  completedAt: {
    fontSize: 10,
    color: theme.colorPalette.green_80
  },
  completedTask: {
    color: theme.colorPalette.beige_75
  },
  tags: {
    marginTop: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1)
  },
  upload: {
    fontSize: 12,
    fontWeight: 600
  },
  uploadIcon: {
    marginLeft: theme.spacing(2)
  },
  completedIcon: {
    height: 24,
    margin: 'auto 0',
    '--completed-icon-stroke': theme.colorPalette.green_legacy_86c440
  },
  pendingIcon: {
    height: '24px',
    width: '24px',
    margin: 'auto 0'
  },
  progressBar: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    left: 0
  },
  filesTooltip: {
    position: 'absolute',
    backgroundColor: 'white',
    borderRadius: theme.sizes.roundCorners,
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
  },
  fileName: {
    padding: theme.spacing(4),
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.colorPalette.beige_25
    }
  },
  taskNameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  learnMoreLink: {
    width: 'auto',
    height: 'auto',
    borderRadius: theme.spacing(2),
    color: theme.colorPalette.orange_50,
    padding: 0,
    marginLeft: theme.spacing(0.2),
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  learnMoreLinkText: {
    fontSize: 10,
    fontWeight: 400,
    color: theme.colorPalette.orange_50
  },
  iconButtons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1)
  },
  actionButton: {
    color: theme.colorPalette.orange_50,
    fontSize: 12,
    fontWeight: 600
  },
  actionButtonIcon: {
    marginRight: theme.spacing(2)
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  tag: {
    fontWeight: 400,
    color: theme.colorPalette.green_90,
    backgroundColor: theme.colorPalette.beige_50,
    '& > img': {
      height: 14,
      margin: theme.spacing(0, 1)
    }
  },
  statusTag: {
    backgroundColor: 'white'
  },
  inlineTaskDescription: {
    display: 'block',
    margin: 4,
    lineHeight: 1.5
  },
  questionIcon: {
    height: 12,
    padding: theme.spacing(0, 0.5)
  },
  approvalSection: {
    width: '185%',
    maxWidth: '650px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(4),
    margin: theme.spacing(4, 0),
    backgroundColor: theme.colorPalette.beige_50,
    borderRadius: theme.spacing(2),
    '& > img': {
      height: 16,
      marginTop: theme.spacing(0.5),
      alignSelf: 'flex-start'
    }
  },
  approvalContent: {
    marginLeft: theme.spacing(2),
    '& > first-child': {
      marginBottom: theme.spacing(2)
    }
  },
  approvalButton: {
    backgroundColor: 'black',
    color: 'white',
    padding: theme.spacing(2),
    '&:hover': {
      backgroundColor: 'black',
      boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)'
    },
    '& > img': {
      marginRight: theme.spacing(2)
    }
  },
  approvalButtonLoading: {
    minWidth: 160,
    pointerEvents: 'none'
  },
  fileMenuItem: {
    maxWidth: 300,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  removeIcon: {
    height: 24,
    width: 24,
    marginRight: theme.spacing(0.5)
  }
});

export default makeStyles(styles);
